/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseFromJSON(json) {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
    };
}
export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseToJSON(json) {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse.js.map